






















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ApolloClient, { serverBase } from "../apollo";
import gql from "graphql-tag";
import CreatedCustomField from "./CreatedCustomField.vue";

@Component({
  components: {
    CreatedCustomField
  }
})
export default class CustomFieldCreator extends Vue {
  fields = [] as any[];

  isCreating = false;
  validated = false;

  createDialog = false;
  createFieldName = "" as string | null;
  createFieldType = "STRING" as string | null;
  createFieldTypes = [
    {
      id: "NUMBER",
      text: "Number"
    },
    {
      id: "STRING",
      text: "String"
    },
    {
      id: "BOOLEAN",
      text: "Boolean"
    },
    {
      id: "SINGLE_SELECT",
      text: "Single choice"
    },
    {
      id: "MULTI_SELECT",
      text: "Multiple choice"
    }
  ];
  createFieldTarget = ["ACTORS"] as string[];
  createFieldTargets = [
    {
      id: "SCENES",
      text: "Scenes"
    },
    {
      id: "ACTORS",
      text: "Actors"
    }
    /* {
      id: "MOVIES",
      text: "Movies"
    },
    {
      id: "IMAGES",
      text: "Images"
    },
    {
      id: "MOVIES",
      text: "Movies"
    },
    {
      id: "ALBUMS",
      text: "Albums"
    } */
  ];
  createFieldValues = [] as string[];
  createFieldUnit = null as string | null;

  fieldNameRules = [v => (!!v && !!v.length) || "Invalid field name"];

  updateField(index: number, field: any) {
    Vue.set(this.fields, index, field);
  }

  createField() {
    if (this.isCreating || !this.validated) return;

    this.isCreating = true;
    setTimeout(() => {
      ApolloClient.mutate({
        mutation: gql`
          mutation(
            $name: String!
            $values: [String!]
            $type: CustomFieldType!
            $unit: String
            $target: [CustomFieldTarget!]!
          ) {
            createCustomField(
              name: $name
              values: $values
              type: $type
              unit: $unit
              target: $target
            ) {
              _id
              name
              type
              values
              unit
              target
            }
          }
        `,
        variables: {
          name: this.createFieldName,
          type: this.createFieldType,
          values: this.createFieldValues,
          unit: this.createFieldUnit,
          target: this.createFieldTarget
        }
      })
        .then(res => {
          this.fields.push(res.data.createCustomField);
          this.createFieldName = "";
          this.createFieldValues = [];
          this.createDialog = false;
          this.createFieldUnit = null;
        })
        .finally(() => {
          this.isCreating = false;
        });
    }, 50);
  }

  get typeHint() {
    switch (this.createFieldType) {
      case "STRING":
        return "Arbitrary string value (e.g. social media link)";
        break;
      case "NUMBER":
        return "Some number (integer or float) (e.g. height in cm)";
        break;
      case "BOOLEAN":
        return "Checkbox (e.g. retired yes/no)";
        break;
      case "SINGLE_SELECT":
        return "Set of values with one possible selected value (e.g. nationality)";
        break;
      case "MULTI_SELECT":
        return "Set of values with more than one possible value (e.g. hair color)";
        break;
      default:
        return "Oops?";
        break;
    }
  }

  openCreateDialog() {
    this.createDialog = true;
  }

  mounted() {
    ApolloClient.query({
      query: gql`
        {
          getCustomFields {
            _id
            name
            type
            values
            unit
            target
          }
        }
      `
    })
      .then(res => {
        this.fields = res.data.getCustomFields;
      })
      .catch(error => {
        console.error(error);
      });
  }
}
